import SnackbarApp from "components/general/Snackbar";
import { ThemeContextProvider } from "context/ThemeContext";
import { ConfirmationDialogContextProvider } from "context/ConfirmationDialogContext";
import { NotificationsContextProvider } from "context/NotificationsContext";
import IChildrenProps from "models/common-props/IChildrenProps";
import { MessageDialogContextProvider } from "./MessageDialogContext";
import { LoadingBackDropContextProvider } from "./LoadingBackDropContext";

export default function AppContextProvider({ children }: IChildrenProps) {
  return (
    <ThemeContextProvider>
      <NotificationsContextProvider>
        <SnackbarApp />
        <ConfirmationDialogContextProvider>
          <MessageDialogContextProvider>
            <LoadingBackDropContextProvider>
              {children}
            </LoadingBackDropContextProvider>
          </MessageDialogContextProvider>
        </ConfirmationDialogContextProvider>
      </NotificationsContextProvider>
    </ThemeContextProvider>
  );
}
